// Resolves a photo_url that may be:
//  - empty
//  - absolute (http/https)
//  - relative path served by backend (/api/files/{id})
// Returns a full URL or empty string.
export function resolvePhotoUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
